// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"6604a647","767":"1251ba93","805":"aaa3229b"}[chunkId] + ".chunk.js";
};